import { DASHBOARD_BUTTON_GROUP } from '../../util/constants';
import { Mui } from "@osu/react-ui"

const ToggleButtonGroup = ({ dispatch, filterState, data }) => {

  return (
    <Mui.ToggleButtonGroup
      value={Object.keys(filterState).filter(key => filterState[key])}
      onChange={(e) => {
        const button = e.target.value;
        switch (button) {
          case DASHBOARD_BUTTON_GROUP.RESUMELATER.KEY:
            dispatch({ type: DASHBOARD_BUTTON_GROUP.RESUMELATER.TYPE });
            break;
          case DASHBOARD_BUTTON_GROUP.ASSIGNED.KEY:
            dispatch({ type: DASHBOARD_BUTTON_GROUP.ASSIGNED.TYPE });
            break;
          default:
            break;
        }
      }}
        aria-label="filters"
    >
      <Mui.ToggleButton value={DASHBOARD_BUTTON_GROUP.ASSIGNED.KEY}>
        Manually Assigned ({data?.inProgressTotals?.manuallyAssigned ?? "?"})
      </Mui.ToggleButton>
      <Mui.ToggleButton value={DASHBOARD_BUTTON_GROUP.RESUMELATER.KEY}>
        Saved for later ({data?.inProgressTotals?.resumeLater ?? "?"})
      </Mui.ToggleButton>
    </Mui.ToggleButtonGroup>
  )
}

export default ToggleButtonGroup